var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 48,
    height: 48,
    transform: "rotate(180 48 48)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28.5L14 39L34 39L34 9L14 9L14 28.5L11 28.5L11 9C11 8.175 11.2937 7.46875 11.8812 6.88125C12.4687 6.29375 13.175 6 14 6L34 6C34.825 6 35.5312 6.29375 36.1187 6.88125C36.7062 7.46875 37 8.175 37 9L37 39C37 39.825 36.7062 40.5312 36.1187 41.1188C35.5312 41.7063 34.825 42 34 42L14 42C13.175 42 12.4688 41.7063 11.8813 41.1188C11.2938 40.5313 11 39.825 11 39L11 28.5L14 28.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24H32M24 32V16",
    stroke: "#999999",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.c7cf02cc797279491ea11dbb4937e570.svg";
export { ForwardRef as ReactComponent };